// Application types

const PUBLICCART = {
  LOADING_CARTS: "LOADING_CARTS",
  ALL_CARTS: "ALL_CARTS",
  PROCESSING: "PROCESSING",
};

export default PUBLICCART;
